import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_MASTER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERIDIC_TASKS_CLOCKED_SCHEDULE(state, periodicTasksClockedSchedule) {
    state.cached = periodicTasksClockedSchedule
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPeriodicTasksClockedSchedule(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/scheduled_tasks/clocked_schedule/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERIDIC_TASKS_CLOCKED_SCHEDULE', request)
      return request
    })
  },

  fetchPeriodicTasksClockedScheduleDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePeriodicTasksClockedSchedule(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formatUrl(formData.url), formData)
    }else {
      promise =  axios.post(`${serverUrl}/scheduled_tasks/clocked_schedule/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deletePeriodicTasksClockedSchedule(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}